/**
 * BestRest Slaapwijzer, advies v5.
 *
 * Rekent met de productkennis uit snippets/br-slaapwijzer-catalog.liquid: ligcomfort
 * (0-100, gelijk aan de specificaties), kern, hoes, dikte, belastbaarheid, split en
 * twee kanten. Uit de antwoorden volgt een ideaal ligcomfort; daarna krijgt elk
 * bestelbaar product in de juiste categorie een score. Producten zonder prijs doen
 * niet mee.
 *
 * Huisregels voor de teksten:
 * - een matras of topper koelt niet; traagschuim houdt warmte vast, de hoes regelt
 *   vocht, alleen de Cooler hoes voelt koel aan
 * - duo = twee kanten die je omdraait, geen kant per partner; verschillen partners in
 *   hardheid, dan twee losse delen
 * - een split is 90 cm lang, geen twee losse helften
 * - geen eigen fabriek, geen "extra stevig", geen Comfort Index
 * - het advies is een indicatie
 */
(function (global) {
  'use strict';

  var ARCHETYPES = {
    warm: {
      id: 'pool',
      naam: 'Warme slaper',
      tagline: 'Jij hebt het snel warm in bed.',
      desc: 'Traagschuim houdt warmte vast. Daarom kijken we bij jou vooral naar koudschuim, latex of pocketvering, met een hoes die vocht afvoert zodat je droog ligt.',
      kenmerken: ['Heeft het snel warm', 'Liever geen traagschuim', 'Hoes die vocht afvoert']
    },
    samen: {
      id: 'duo',
      naam: 'Samenslaper',
      tagline: 'Jij deelt het bed.',
      desc: 'Samen slapen vraagt om genoeg ruimte. Willen jullie een andere hardheid, dan kies je twee losse delen, elk met een eigen ligcomfort.',
      kenmerken: ['Deelt het bed', 'Maat voor twee', 'Eigen hardheid met twee delen']
    },
    steun: {
      id: 'anker',
      naam: 'Steunslaper',
      tagline: 'Jij wilt stevige steun onder je rug.',
      desc: 'Je lichaam vraagt om een kern die draagt zonder door te zakken, zodat je rug recht blijft.',
      kenmerken: ['Rug recht', 'Stevige kern', 'Niet wegzakken']
    },
    zacht: {
      id: 'wolk',
      naam: 'Comfortslaper',
      tagline: 'Jij wilt zacht liggen, met genoeg steun.',
      desc: 'Schouders en heupen mogen wat wegzakken, terwijl je rug gedragen blijft. Traagschuim vormt mee en verlicht druk.',
      kenmerken: ['Drukverlichting op schouders en heupen', 'Zacht liggen', 'Met genoeg steun']
    },
    waarde: {
      id: 'nuchter',
      naam: 'Waardebewuste slaper',
      tagline: 'Jij zoekt goede kwaliteit voor een eerlijke prijs.',
      desc: 'Je wilt een product dat doet wat het belooft, zonder er te veel voor te betalen. Nederlands fabrikaat, en je kunt thuis proefslapen.',
      kenmerken: ['Eerlijke prijs-kwaliteit', 'Nederlands fabrikaat', 'Thuis proefslapen']
    },
    wissel: {
      id: 'vogel',
      naam: 'Wisselslaper',
      tagline: 'Jij wisselt van houding.',
      desc: 'Zij, rug of buik: je ligt niet in één vaste houding. Een veerkrachtige kern maakt draaien makkelijk.',
      kenmerken: ['Wisselt van houding', 'Veerkrachtig', 'Makkelijk draaien']
    }
  };

  function hasHuidig(a, key) {
    return !!(a.huidig && a.huidig.indexOf(key) >= 0);
  }

  function gw(a) {
    return typeof a.gewicht === 'number' ? a.gewicht : 2;
  }

  function resolvedDoel(a) {
    if (a.doel === 'matras' || a.doel === 'topper') return a.doel;
    if (hasHuidig(a, 'zacht') || hasHuidig(a, 'oud') || hasHuidig(a, 'geen')) return 'matras';
    if (hasHuidig(a, 'hard') || hasHuidig(a, 'prima')) return 'topper';
    return 'matras';
  }

  function needsSplit(a) {
    return a.bodem === 'elektrisch' && a.bed === 'partner' && a.verstel === 'apart';
  }

  function verschillendeHardheid(a) {
    return a.bed === 'partner' && a.hardheid === 'verschil';
  }

  function heeftHetWarm(a) {
    return a.prioriteit === 'koel' || hasHuidig(a, 'warm');
  }

  function clamp(x, lo, hi) {
    return Math.max(lo, Math.min(hi, x));
  }

  /* Ideaal ligcomfort, 0-100. Zelfde schaal als de catalogus. */
  function computeFirmness(a) {
    var f = 54;
    if (a.houding === 'zij') f -= 12;
    if (a.houding === 'buik') f += 4;
    if (a.houding === 'rug') f += 4;
    if (a.prioriteit === 'steun') f += 10;
    if (a.prioriteit === 'comfort') f -= 10;
    if (hasHuidig(a, 'hard')) f -= 8;
    if (hasHuidig(a, 'zacht')) f += 6;
    var w = gw(a);
    if (w === 0) f -= 6;
    if (w === 1) f -= 3;
    if (w === 3) f += 7;
    if (w >= 4) f += 12;
    return clamp(f, 22, 86);
  }

  function firmnessLabel(f) {
    if (f < 40) return 'Zacht';
    if (f < 50) return 'Zacht tot medium';
    if (f < 62) return 'Medium';
    if (f < 70) return 'Medium tot stevig';
    return 'Stevig';
  }

  /* Plek op de balk Zacht | Medium | Stevig. */
  function firmnessPct(f) {
    return Math.round(clamp((f - 22) / (86 - 22) * 100, 2, 98));
  }

  function computeArchetype(a) {
    if (heeftHetWarm(a)) return ARCHETYPES.warm;
    if (verschillendeHardheid(a)) return ARCHETYPES.samen;
    if (a.prioriteit === 'steun') return ARCHETYPES.steun;
    if (a.prioriteit === 'comfort') return ARCHETYPES.zacht;
    if (a.prioriteit === 'waarde') return ARCHETYPES.waarde;
    if (a.houding === 'zij') return ARCHETYPES.zacht;
    if (a.houding === 'rug' || a.houding === 'buik') return ARCHETYPES.steun;
    if (a.bed === 'partner') return ARCHETYPES.samen;
    return ARCHETYPES.wissel;
  }

  /* Welke producten komen in aanmerking: categorie, bestelbaar, split of niet. */
  function filterCatalog(catalog, a) {
    var cat = resolvedDoel(a);
    var split = cat === 'topper' && needsSplit(a) && !verschillendeHardheid(a);
    var inCat = (catalog || []).filter(function (p) {
      return p.category === cat && p.beschikbaar !== false;
    });
    var pool = inCat.filter(function (p) {
      return cat !== 'topper' || !!p.isSplit === split;
    });
    return pool.length ? pool : inCat;
  }

  function prijsRang(pool) {
    var prijzen = pool.map(function (p) { return p.prijs || 0; });
    var lo = Math.min.apply(null, prijzen);
    var hi = Math.max.apply(null, prijzen);
    return function (p) {
      if (hi <= lo) return 0;
      return ((p.prijs || lo) - lo) / (hi - lo);
    };
  }

  function scoreProduct(p, a, ideaal, rang) {
    var s = 100 - Math.abs((p.stevig || 50) - ideaal) * 1.6;
    var warm = heeftHetWarm(a);

    if (warm && p.traag) s -= 45;
    if (warm && (p.hoes === 'tencel' || p.hoes === 'tencel3d' || p.hoes === 'cooltouch')) s += 3;
    if (!warm && a.houding === 'zij' && p.traag && !p.tweeKanten) s += 4;
    if (a.houding === 'wissel' && (p.kern === 'latex' || p.kern === 'hr')) s += 4;
    if (a.prioriteit === 'steun' && (p.kern === 'hr55' || p.kern === 'hr50')) s += 5;

    /* Twee kanten past bij wie tussen zacht en medium zit, niet bij wie weet wat hij wil. */
    if (p.tweeKanten) s += (ideaal >= 40 && ideaal <= 52) ? 3 : -12;

    if (a.prioriteit === 'waarde') s -= rang(p) * 18;

    if (p.category === 'topper') {
      var wens = 10;
      if (gw(a) >= 3 || hasHuidig(a, 'hard')) wens = 12;
      if (a.prioriteit === 'waarde') wens = 7;
      s -= Math.abs((p.dikte || 10) - wens) * 1.5;
    } else {
      if (a.bodem === 'elektrisch' && p.flex) s += 8;
      if (a.bed === 'partner' && p.pocket) s += 3;
      if (gw(a) >= 4 && p.belastbaar >= 130) s += 5;
    }
    if (gw(a) >= 4 && (p.belastbaar || 120) < 120) s -= 10;
    return s;
  }

  function kernZin(p) {
    switch (p.kern) {
      case 'nasa':
        return p.category === 'topper'
          ? 'Nasa traagschuim vormt mee met je lichaam en verlicht druk op schouders en heupen.'
          : 'De comfortlaag van Nasa traagschuim vormt mee en verlicht druk op schouders en heupen.';
      case 'sg85':
        return 'SG85 Nasa traagschuim vormt mee en verlicht druk. De Cooler hoes voelt koel aan.';
      case 'hr':
        return (p.lijn === 'ct7' ? 'Hybridefoam koudschuim' : 'Hybride koudschuim') + ' veert direct terug en ligt medium.';
      case 'hr50':
        return 'De comfortlaag van HR koudschuim veert direct terug en geeft steun.';
      case 'hr55':
        return 'HR55 koudschuim ligt stevig en veert direct terug. Je ligt erop in plaats van erin.';
      case 'latex':
        return 'Latex veert direct terug, zodat draaien makkelijk gaat.';
      case 'duo':
        return 'Twee kanten: hybride koudschuim en traagschuim. Draai de topper om naar de kant die het beste ligt.';
      case 'duolatex':
        return 'Twee kanten: latex en HR55 koudschuim. Draai het matras om naar de kant die het beste ligt.';
      case '2in1':
        return 'Twee kanten, medium en stevig. Draai het matras om naar de kant die het beste ligt.';
      case 'hybrid':
        return 'De kern van Hybridefoam ligt medium en is geschikt voor vlakke en verstelbare bodems.';
      case 'comfortschuim':
        return 'Pocketvering met een comfortlaag: stevig en voordelig.';
      default:
        return '';
    }
  }

  /* Wat de hoes doet, zoals op de productpagina. Geen koelclaim: alleen de Cooler hoes voelt koel aan. */
  function hoesZin(p, warm) {
    switch (p.hoes) {
      case 'tencel':
        return warm
          ? 'De Tencel hoes neemt vocht op en voert het af, zodat je droog ligt.'
          : 'De afritsbare Tencel hoes voelt zacht aan en neemt vocht op.';
      case 'tencel3d':
        return 'De afritsbare Tencel hoes neemt vocht op. Rondom loopt een 3D ventilatieborder.';
      case 'cooltouch':
        return 'De Cooltouch hoes heeft een open weefstructuur, zodat vocht beter wordt afgevoerd.';
      case 'bamboo':
        return 'De Bamboo 3D Exclusive hoes voelt zacht aan en neemt vocht op.';
      case 'prestige':
        return 'De Prestige 3D-hoes laat rondom lucht door.';
      default:
        return '';
    }
  }

  function buildReasons(p, a) {
    var pts = [];
    var zin = kernZin(p);
    if (zin) pts.push(zin);

    if (hasHuidig(a, 'hard') && p.category === 'topper') {
      pts.push('Je matras voelt te hard, maar is verder nog goed. Een topper verandert het ligcomfort zonder nieuw matras.');
    }
    if (p.category === 'topper' && (hasHuidig(a, 'zacht') || hasHuidig(a, 'oud'))) {
      pts.push('Let op: zakt je matras door, dan lost een topper dat niet op. Kijk dan ook naar een nieuw matras.');
    }
    if (p.category === 'matras' && (hasHuidig(a, 'zacht') || hasHuidig(a, 'oud'))) {
      pts.push('Je matras zakt door of is ouder dan 8 jaar. Een topper lost dat niet op, een nieuw matras wel.');
    }
    if (heeftHetWarm(a) && !p.traag) {
      pts.push('Je hebt het snel warm. Traagschuim houdt warmte vast, daarom zit dat niet in dit advies.');
    }
    var hoes = hoesZin(p, heeftHetWarm(a));
    if (hoes) pts.push(hoes);
    if (p.category === 'matras' && a.bodem === 'elektrisch' && p.flex && p.kern !== 'hybrid') {
      pts.push('Geschikt voor vlakke en verstelbare bodems.');
    }
    if (a.bed === 'partner' && p.pocket && !verschillendeHardheid(a)) {
      pts.push('Pocketveren veren per veer mee, dus je merkt minder van je partner als die draait.');
    }
    if (gw(a) >= 4 && p.belastbaar >= 130) {
      pts.push('Belastbaar tot 130 kg per persoon.');
    }
    if (a.prioriteit === 'waarde') {
      pts.push('Een eerlijke prijs voor Nederlands fabrikaat, met ' + (p.proef || '30 nachten proefslapen') + '.');
    }
    if (pts.length < 2) {
      pts.push('Dit advies volgt je antwoorden over houding, gewicht, bedbodem en wat je belangrijk vindt.');
    }
    return pts.slice(0, 4);
  }

  function buildFormatNote(p, a) {
    var soort = p.category === 'topper' ? 'toppers' : 'matrassen';
    if (verschillendeHardheid(a)) {
      return {
        title: 'Twee losse delen',
        text: 'Willen jullie een andere hardheid? Kies dan twee losse ' + soort + ', bijvoorbeeld 2× 80×200 bij een bed van 160×200. Dit advies is voor jouw kant; je partner kan de Slaapwijzer ook doen.'
      };
    }
    if (needsSplit(a) && p.category === 'topper') {
      return {
        title: 'Split, voor een verstelbaar bed',
        text: 'Jullie bed beweegt per kant. Deze topper heeft een split van 90 cm, zodat elke kant apart kan bewegen.'
      };
    }
    if (needsSplit(a) && p.category === 'matras') {
      return {
        title: 'Twee losse matrassen',
        text: 'Op een bed waarvan de kanten apart bewegen leg je twee losse matrassen, bijvoorbeeld 2× 80×200 bij een bed van 160×200.'
      };
    }
    if (a.bodem === 'elektrisch' && p.category === 'topper') {
      return {
        title: 'Eén geheel is prima',
        text: 'Je bed beweegt als één geheel, dus een topper uit één stuk past.'
      };
    }
    if (a.bed === 'partner') {
      return {
        title: 'Maat voor twee',
        text: 'Kies minimaal 160×200, zodat jullie allebei genoeg ruimte hebben.'
      };
    }
    return null;
  }

  function cleanTitle(raw, handle) {
    var t = (raw || '').trim();
    if (!t || t === handle) return 'Aanbevolen product';
    return t;
  }

  /*
   * Matchpercentage: hoe dicht het ligcomfort van het product bij je ideaal ligt, en of
   * het de beste keuze is. Het blijft een indicatie.
   */
  function matchPercent(p, ideaal, isBeste) {
    var afstand = Math.abs((p.stevig || 50) - ideaal);
    var fit = Math.max(0, 1 - afstand / 45);
    var ratio = 0.6 * fit + 0.4 * (isBeste ? 1 : 0.6);
    return clamp(Math.round(62 + ratio * 34), 62, 96);
  }

  function compute(catalog, answers) {
    var pool = filterCatalog(catalog, answers);
    if (!pool.length) return null;

    var ideaal = computeFirmness(answers);
    var rang = prijsRang(pool);
    var scored = pool.map(function (p, i) {
      return { product: p, score: scoreProduct(p, answers, ideaal, rang), i: i };
    }).sort(function (x, y) { return (y.score - x.score) || (x.i - y.i); });

    var winner = scored[0].product;
    var warm = heeftHetWarm(answers);
    var alt = scored.slice(1).filter(function (x) {
      return x.product.handle !== winner.handle && !(warm && x.product.traag);
    }).slice(0, 2);
    var arch = computeArchetype(answers);
    var title = cleanTitle(winner.title, winner.handle);

    return {
      product: title,
      shortTitle: cleanTitle(winner.shortTitle || winner.title, winner.handle),
      handle: winner.handle,
      url: winner.url,
      price: winner.price,
      image: winner.image,
      badge: winner.badge,
      proef: winner.proef,
      ctaLabel: 'Bekijk product',
      sub: 'Past bij het ligcomfort dat bij jou hoort: ' + firmnessLabel(ideaal).toLowerCase() + '.',
      archetype: arch,
      firmnessPct: firmnessPct(ideaal),
      firmnessLabel: firmnessLabel(ideaal),
      match: matchPercent(winner, ideaal, true),
      points: buildReasons(winner, answers),
      formatNote: buildFormatNote(winner, answers),
      doelResolved: resolvedDoel(answers),
      needsSplit: needsSplit(answers),
      alternates: alt.map(function (x) {
        return {
          title: cleanTitle(x.product.shortTitle || x.product.title, x.product.handle),
          url: x.product.url,
          price: x.product.price,
          match: matchPercent(x.product, ideaal, false)
        };
      }).sort(function (x, y) { return y.match - x.match; }),
      productKey: winner.category === 'topper' ? 'topper' : (winner.pocket ? 'pocket' : 'hr'),
      meta: {
        image: winner.image,
        badge: winner.badge,
        perk: 'gratis verzending en 2 jaar garantie',
        alt: title
      }
    };
  }

  function loadCatalog() {
    var el = document.getElementById('br-sa-catalog-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  var api = {
    compute: compute,
    loadCatalog: loadCatalog,
    firmnessLabel: firmnessLabel,
    computeFirmness: computeFirmness,
    computeArchetype: computeArchetype,
    resolvedDoel: resolvedDoel,
    needsSplit: needsSplit,
    filterCatalog: filterCatalog,
    archetypes: ARCHETYPES
  };

  global.BRSlaapwijzer = api;
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : this);
